import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { animateScroll } from "react-scroll";
import { withCookies } from 'react-cookie';

import * as PaymentActions from "../actions/PaymentActions";
import * as CartActions from "../actions/CartActions";
import { setUserAccount } from "../actions/AccountActions";
import { setPaymentPlan } from "../actions/PaymentPlanActions";

import PaymentPage from "./PaymentPage";
import Footer from "./Footer";

import { getOrderCookie, getMyOrder, mapForCart, getAllProductItems, titleCaseStr, addProductToOrder, getProductType, addCouponCode } from "../utils";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }
  

  componentDidMount = async () => {
    const { actions, cartActions, onSetUserAccount, onSetPaymentPlan } = this.props;
    actions.setLoading(true);
    const urlParams = new URLSearchParams(window.location.search);
    const productItem = ((productParam) => {
      if (typeof productParam === 'string') {
        const splitted = productParam.split('_');
        if (splitted.length > 1) {
          const [ abbr, id ] = splitted;
          if (getProductType(abbr)) {
            return { modelId: id, onModel: getProductType(abbr) };
          }
        }
      }
      return null;
    })(urlParams.get('pid'));
    const couponCode = urlParams.get('cc');

    let orderRes, items;

    try {
      orderRes = await getMyOrder();
      if (orderRes && orderRes.paymentPlan && orderRes.paymentPlan.owing) orderRes.paymentPlan.owing = Number(orderRes.paymentPlan.owing.toFixed(2));
    } catch (error) {
      console.error(error);
    }

    try {
      items = await getAllProductItems();
    } catch (error) {
      console.error(error);
    }

    if (Array.isArray(items)) actions.setSearchableProducts(items.map(({ name, type, _id, hasSubscription }) => ({ label: name, groupBy: titleCaseStr(type), value: { modelId: _id, onModel: type, hasSubscription } })));

    if (!orderRes || !orderRes.ok) {
      const { status, message } = orderRes;
      if (status === 400) await getOrderCookie();
      else if (status > 400) actions.openSnackbar('error', message || 'Unknown Error 2');
    }
    else {
      const { order, user: userAccount, paymentPlan } = orderRes;
      
      if (order && order.items && Array.isArray(order.items)) {
        cartActions.setCart({ ...order, items: order.items.map(mapForCart) });
      }

      if (paymentPlan) {
        onSetPaymentPlan({ ...paymentPlan, items: paymentPlan.items.map(mapForCart) });
      }

      if (userAccount) {
        onSetUserAccount(userAccount);
        actions.setStep(3);
      }
    }

    // apply product
    if (productItem) {
      try {
        const { order } = await addProductToOrder({ items: [productItem] }); 

        if (order) {
          cartActions.setCart({ ...order, items: order.items.map(mapForCart) });
          actions.openSnackbar('success', `Product is added to your cart`);
        } else throw new Error(`Failed to Add product to your cart`);
      } catch (error) {
        console.error(error);
        actions.openSnackbar('error', 'Failed to Add product to your cart');
      } finally {
        window.history.replaceState({}, document.title, window.location.href.split('?')[0]);
        actions.setLoading(false);
      }
    }

    // apply coupon code
    if (couponCode && couponCode !== '') {
      try {
        const { order } = await addCouponCode(couponCode);
  
        if (order) {
          actions.openSnackbar('success', 'Cart Populated');
          cartActions.setCart({ ...order, items: order.items.map(mapForCart) });
        } else throw new Error('Failed to populate cart');
      } catch (error) {
        console.error(error);
        actions.openSnackbar('error', 'Failed to populate your cart');
      } finally {
        window.history.replaceState({}, document.title, window.location.href.split('?')[0]);
        actions.setLoading(false);
      }
    } else actions.setLoading(false);
  };

  componentDidUpdate = (prevProps) => {
    if(this.props.step !== prevProps.step) {
      animateScroll.scrollTo(1);
    }
  }

  render = () => {
    return (<>
      <div>
        <PaymentPage />
      </div>
      <Footer />
    </>);
  };
}

App.propTypes = {
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = ({ payment, ...rest }) => ({
  loading: payment.loading,
  step: payment.step,
  snackbar: payment.snackbar,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
  cartActions: bindActionCreators(CartActions, dispatch),
  onSetUserAccount: (userAccount) => dispatch(setUserAccount(userAccount)),
  onSetPaymentPlan: (paymentPlan) => dispatch(setPaymentPlan(paymentPlan)),
});

export default withCookies(connect(mapStateToProps, mapDispatchToProps)(App));
